import React from 'react';
import { Section } from './Shared';
const INSIDE_VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/tWqZL1wGGTWFx4yoSxSHtb/Scroll_Chi_Kung_Optimizado_Magic_Patterns.mp4';
const included = ['Lezioni già strutturate e pronte da utilizzare come base', 'Criteri per organizzare apertura, sviluppo e chiusura dell’incontro', 'Riferimenti visivi per spiegare meglio posizioni e movimenti', 'Strumenti per adattare la pratica a gruppi, livelli e spazi diversi', 'Schede per osservare, registrare e seguire il percorso degli allievi'];
export const InsideLook = () => <Section id="inside" className="max-w-4xl" data-id="element-141" data-mp="2h83uknksz6o3">
    <div className="text-center mb-8" data-id="element-142" data-mp="2h7aweazwtphk">
      <h2 className="font-seal text-sm md:text-xl uppercase tracking-seal text-brand-burgundy" data-id="element-143" data-mp="2h69k6375qwy9">
        Mega Pack Qi Gong™
      </h2>
      <p className="mt-5 mx-auto max-w-2xl font-display text-lg md:text-2xl leading-snug text-brand-textLight" data-id="element-144" data-mp="39w86vrxvqhzr">
        Conoscere molti esercizi non significa automaticamente sapere come
        costruire una lezione efficace. Il vero lavoro dell’istruttore è
        collegare obiettivi, movimenti, tempi e progressioni in un percorso
        comprensibile per ogni gruppo.
      </p>
    </div>

    <ul className="mx-auto mb-12 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-145" data-mp="2bm8hkh81q8fo">
      {included.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-146" data-mp="26u6xi94mzdf3">
          <span aria-hidden="true" className="mt-2 w-1.5 h-1.5 rotate-45 bg-brand-gold shrink-0" data-id="element-147" data-mp="2ljmljhcs94r3" />
          <span className="text-sm text-brand-text/85" data-id="element-148" data-mp="2gk06r3hb3gg6">{item}</span>
        </li>)}
    </ul>

    <p className="mx-auto mb-10 max-w-2xl text-center text-sm md:text-base text-brand-muted" data-id="element-149" data-mp="2ujhxhoe5x3s6">
      Non è un corso video e non sostituisce la formazione di un istruttore. È
      una biblioteca operativa da consultare mentre prepari le tue lezioni e
      mentre lavori con il gruppo.
    </p>

    <p className="mb-8 text-center font-display italic text-2xl md:text-3xl text-brand-goldDark" data-id="element-150" data-mp="v8i96y9w8y08">
      Guarda il materiale dall’interno
    </p>

    <div className="mx-auto max-w-xl" data-id="element-151" data-mp="2vc1ams96fagu">
      <div className="glass-panel gold-frame rounded-sm p-3 md:p-4" data-id="element-152" data-mp="307zty1fne2ae">
        <video src={INSIDE_VIDEO_URL} className="w-full rounded-sm border border-brand-gold/30 bg-brand-surfaceLight/40" autoPlay muted loop playsInline controls preload="metadata" aria-label="Anteprima delle pagine interne del Mega Pack Qi Gong" data-id="element-153" data-mp="357vxjzkfnrpf" />
      </div>

      <p className="mt-4 text-center text-xs md:text-sm text-brand-muted" data-id="element-154" data-mp="3j62n8sf8ale0">
        Un passaggio reale tra le pagine del sistema
      </p>
    </div>
  </Section>;